import { Col, Row } from 'antd'
import { map } from 'lodash'
import './styles.less'

type PROPS = {
  temp: any[]
  getCellValue: (item: any) => string
  WIDE_COLUMNS: { [key: string]: { span: number } }
}

function GroupEntryTableComponent({ temp, getCellValue, WIDE_COLUMNS }: PROPS) {
  if (!temp || temp.length === 0) {
    return null
  }

  const cleanedTemp = temp.map((group) =>
    group.filter((item) => item.key !== 'checkpoint_id')
  )

  const headers = ['SL', ...(cleanedTemp[0]?.map((item) => item.title) || [])]
  const numFields = headers.length
  const baseSpan = Math.floor(24 / numFields)

  const renderHeader = () => {
    return map(headers, (header, idx) => {
      const colSpan = WIDE_COLUMNS[header] ? WIDE_COLUMNS[header].span : 2
      return (
        <Col key={idx} span={colSpan}>
          <p className="header" style={{ textAlign: 'center' }}>
            {header}
          </p>
        </Col>
      )
    })
  }

  const renderHeaderRow = () => (
    <Row className="section-header-container custom-table-header">
      {renderHeader()}
    </Row>
  )

  const renderValueRows = () => {
    return map(cleanedTemp, (group, groupIdx) => {
      const renderColItem = map(group, (item, idx) => {
        const numIdx = +idx
        const headerIdx = numIdx + 1
        const colSpan = WIDE_COLUMNS[headers[headerIdx]]
          ? WIDE_COLUMNS[headers[headerIdx]].span
          : 2

        return (
          <Col key={idx} span={colSpan}>
            <p className="value" style={{ textAlign: 'center' }}>
              {getCellValue(item)}
            </p>
          </Col>
        )
      })

      return (
        <Row
          key={groupIdx}
          className="section-value-container custom-table-row"
        >
          <Col span={baseSpan}>
            <p className="value" style={{ textAlign: 'center' }}>
              {groupIdx + 1}
            </p>
          </Col>
          {renderColItem}
        </Row>
      )
    })
  }

  return (
    <div className="summary-lot-container">
      {renderHeaderRow()}
      {renderValueRows()}
    </div>
  )
}

export default GroupEntryTableComponent
